/* eslint-disable react-hooks/exhaustive-deps */
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {useState} from "react";

const CurrencyListUnassignedFilterComponent = () => {
    const {updateState, state} = useQueryRequest()
    const [isChecked, setIsChecked] = useState<boolean>(state.filter.unassigned !== undefined);

    const filterData = (e) => {
        setIsChecked(!isChecked);
        if(!isChecked){
            updateState({
                ...state,
                filter: {...state.filter, unassigned: 1},
            })
        }else{
            delete state.filter.unassigned
            updateState({
                ...state,
                filter: {...state.filter},
            })
        }

    }

    return (
        // <div className='card-title'>
            <div className='d-flex align-items-center my-1'>
                <div className="form-check form-check-custom form-check-solid">
                    <input
                        className='form-check-input'
                        type='checkbox'
                        onChange={filterData}
                        checked={isChecked}
                    />
                    <label className="form-check-label" htmlFor="flexCheckChecked">
                        Show Unassigned Currency
                    </label>
                </div>
            </div>
        // </div>
    )
}

export {CurrencyListUnassignedFilterComponent}
